// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getFirestore } from 'firebase/firestore';
// import { getAuth } from 'firebase/auth';
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyADJDlaY-p_s6BcUKJ9oCZDAvjimBIk4qs",
//   authDomain: "kjb-tracker.firebaseapp.com",
//   projectId: "kjb-tracker",
//   storageBucket: "kjb-tracker.firebasestorage.app",
//   messagingSenderId: "638485549995",
//   appId: "1:638485549995:web:03e6a7caf80ee56830b8ee"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// // Initialize Firestore
// const db = getFirestore(app);

// // Initialize Authentication
// const auth = getAuth(app);

// export { db, auth };

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};
// const firebaseConfig = {
//   apiKey: "AIzaSyADJDlaY-p_s6BcUKJ9oCZDAvjimBIk4qs",
//   authDomain: "kjb-tracker.firebaseapp.com",
//   projectId: "kjb-tracker",
//   storageBucket: "kjb-tracker.firebasestorage.app",
//   messagingSenderId: "638485549995",
//   appId: "1:638485549995:web:03e6a7caf80ee56830b8ee"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firestore
const db = getFirestore(app);
// Initialize Authentication
const auth = getAuth(app);

export { db, auth };